import { getToken, setToken, removeToken } from '@/assets/scripts/utils/auth';
import {
    login
} from '@/assets/api/login';

const state = {
    token: getToken(),
    name: '',
    avatar: '',
    introduction: '',
    countryList:[],
    userInfo:{},
    roles: []
};

const mutations = {
    SET_TOKEN: (state, token) => {
        state.token = token;
    },
    SET_INTRODUCTION: (state, introduction) => {
        state.introduction = introduction;
    },
    SET_NAME: (state, name) => {
        state.name = name;
    },
    SET_AVATAR: (state, avatar) => {
        state.avatar = avatar;
    },
    SET_ROLES: (state, roles) => {
        state.roles = roles;
    },
    SET_USER_INFO: (state, userInfo) => {
        state.userInfo = userInfo;
    },
    SET_COUNTRYList:(state,countryList) =>{
        state.countryList = countryList;
    }
};

const actions = {
    login({ commit }, param) {
        return new Promise((resolve, reject) => {
            login(param).then(response => {
                const { data } = response;

                commit('SET_TOKEN', data.token);
                setToken(data.token);
                resolve()
            }).catch(error => {
                reject(error);
            });
        });
    },
    // logout({ commit, state, dispatch }) {
    //     return new Promise((resolve, reject) => {
    //         // logout(state).then(() => {
    //         //     commit('SET_TOKEN', '');
    //         //     commit('SET_ROLES', []);
    //         //     removeToken();

    //         //     dispatch('tagsView/delAllViews', null, { root: true });

    //         //     resolve();
    //         // }).catch(error => {
    //         //     reject(error);
    //         // })
    //     });
    // },
    resetToken({ commit }) {
        return new Promise(resolve => {
            commit('SET_TOKEN', '');
            commit('SET_ROLES', []);
            removeToken();
            resolve();
        })
    },
    async setToken({ commit },token){
       commit('SET_TOKEN', token);
       await setToken(token);
    }
};

export default {
    namespaced: true,
    state,
    mutations,
    actions
};